import { Fragment, ReactElement, useMemo } from 'react';
import { CivilUnionNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CivilUnionNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CivilUnionNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CivilUnionNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import PersonCivilUnionNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-civil-union-non-resident/edit-person';

interface PersonCivilUnionNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
}

const PersonCivilUnionNonResidentNotificationCivilStatusShared = ({
  scope,
}: PersonCivilUnionNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return CivilUnionNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CivilUnionNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CivilUnionNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CivilUnionNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CivilUnionNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <PersonCivilUnionNonResidentNotificationShared
        redirectUrl={redirectUrl}
        goBackUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

PersonCivilUnionNonResidentNotificationCivilStatusShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonCivilUnionNonResidentNotificationCivilStatusShared;
